<template>
  <div class="container">
    <div style="padding:30px 0;text-align:left">
      <el-form class="demo-form-inline" size="medium" :inline="true">
        <el-form-item prop="title">
          <div style="display:flex;">
            <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">书屋位置</div>
            <el-select v-model="search.StrLibraryID" placeholder="请选择" @change="onLibraryChange">
              <el-option
                  v-for="item in swList"
                  :key="item.StrID"
                  :label="item.StrName"
                  :value="item.StrID"
              />
            </el-select>
          </div>
        </el-form-item>

        <el-form-item prop="title">
          <div style="display:flex;">
            <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">选择班级</div>
            <el-select v-model="queryClass" placeholder="请选择" @change="onClassChange">
              <el-option
                  v-for="item in list"
                  :key="item.StrID"
                  :label="item.StrName"
                  :value="item.StrID"
              />
            </el-select>
          </div>
        </el-form-item>


<!--        <el-form-item prop="title">-->
<!--          <div style="display:flex;">-->
<!--            <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">选择读者</div>-->
<!--            <el-select v-model="strReaderCardNumber" placeholder="请选择" >-->
<!--              <el-option-->
<!--                  v-for="item in readerList"-->
<!--                  :key="item.StrID"-->
<!--                  :label="item.StrName"-->
<!--                  :value="item.StrReaderCardNumber"-->
<!--              />-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </el-form-item>-->

        <el-form-item prop="title">
          <div style="display: flex; flex-direction: column;">
            <!-- 顶部：标题+选择器 -->
            <div style="display:flex; align-items: center;">
              <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">
                选择读者
              </div>
              <el-select v-model="strReaderCardNumber" placeholder="请选择">
                <el-option
                    v-for="item in readerList"
                    :key="item.StrID"
                    :label="checkReaderOption ? item.StrReaderCardNumber : item.StrName"
                    :value="item.StrReaderCardNumber"
                />
              </el-select>
            </div>
            <!-- 底部：复选框 -->
            <div style="margin-top: 4px; margin-left: 90px;">
              <el-checkbox v-model="checkReaderOption">显示卡号</el-checkbox>
            </div>
          </div>
        </el-form-item>


        <el-form-item prop="title">
          <div style="display:flex;">
            <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">借阅时间</div>
            <el-config-provider :locale="zhCn">
              <el-date-picker
                  v-model="BorrowTime"
                  type="date"
                  placeholder="借阅时间"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
              />
            </el-config-provider>
          </div>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <div style="display:flex;">-->
<!--            <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">读者卡号</div>-->
<!--            <el-input v-model="strReaderCardNumber" @keyup.enter.prevent="" />-->
<!--          </div>-->
<!--        </el-form-item>-->
        <el-form-item>
          <div style="display:flex;">
            <div style="color:#46c169;font-weight:bold;flex-grow:0;flex-shrink:0;text-align:right;padding-right:10px;width:150px;font-size: 16px;">归还天数</div>
            <div style="width: 240px">
              <el-slider
                  :min="1"
                  :max="30"
                  v-model="returnday">
              </el-slider>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div style="display:flex;">
            <el-button type="success" style="margin-left: 100px;font-size: 16px" @click="borrowBook">模拟借书</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div style="display: flex;justify-content:space-around">
      <el-card class="box-card" shadow="hover" v-loading="listLoading">
        <div slot="header" class="clearfix">
          <span>图书列表</span>
<!--          <el-checkbox v-model="selectAll" @change="handleSelectAll" style="float: right;">全选</el-checkbox>-->
          <div style="text-align: left; margin-top: 10px;margin-bottom: -10px; margin-left: 25px;">
            <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="text item" style="height: 400px;overflow: auto">
          <el-tree
              ref="bookListTree"
              :data="bookList"
              show-checkbox
              @check="bookListNodeClick"
              node-key="StrNodeId"
              :props="defaultProps"
              :expand-on-click-node="false"
              :check-on-click-node="true"
              empty-text=""
              :indent="0"
              default-expand-all/>
        </div>

        <div style="display: flex;justify-content: space-around">
          <el-pagination
              background
              small
              hide-on-single-page
              :total="total"
              :current-page="listQuery.page"
              :page-size="listQuery.perPage"
              :page-sizes="[10, 20, 30, 50, 100]"
              layout="prev,pager,next,sizes,jumper"
              @size-change="handleSizeChange"
              @current-change="currPageChange"/>
        </div>

      </el-card>

      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>已选择的图书列表</span>
          <el-button style="float: right;" type="primary" @click="clearchoosebook">清空列表</el-button>
        </div>
        <el-divider></el-divider>
        <div class="text item" style="max-height: 450px;overflow: auto">
          <div v-for="book in chooseshowbook" :key="book.code" style="margin-left: 20px;font-size: 14px;line-height: 26px">
            {{ book.title }}
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import {BASE_URL} from "@/utils/constants";
export default {
  name: "fastBorrowAndReturn",
  data() {
    return {
      checkReaderOption: false,
      BorrowTime:null,
      readerList:null,
      queryClass:null,
      listQueryClass: {
        Page: 1,
        Perpage: 100,
        intNotOn:"1",
        Sort:"-1",
        OrderBy: "DTCreatedDate",
      },
      list:null,
      search: {
        DTStartCreatedDate: '',
        DTEndCreatedDate: ''
      },
      swList: [],
      strReaderCardNumber: '',
      returnday: 10,
      strBookBarcodes: '',
      selectAll: false, // Track "Select All" checkbox state
      listQuery: {
        page: 1,
        perPage: 30,
        intNotOn: "1",
        Sort: "-1",
        OrderBy: "DTCreatedDate",
        Search: {
          IsBorrowed: false,
        }
      },
      total: 100,
      listLoading: true,
      bookList: [],
      pageNum: 1,
      choose: [
        {
          page: 1,
          books: []
        }
      ],
      chooseshowbook: [],
      defaultProps: {
        label: 'label',
        children: 'children'
      }
    }
  },
  computed: {
    zhCn() {
      return zhCn
    },
  },
  mounted() {
    this.getBookList();
    this.getSWList();
    this.getList();//获取班级信息
  },
  methods: {
    disabledDate (time)  {
      return time.getTime() > Date.now()
    },

    onClassChange(){
      const param = {
        Page:1,
        Perpage:100,
        Sort:"-1",
        OrderBy:"DTCreatedDate",
        Search:{
          StrGroupID:this.queryClass,
        }
      }
      this.$axios({
        url: BASE_URL + 'readers/search',
        method: 'post',
        data: JSON.stringify(param),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.readerList = null
          this.readerList = res.data.msg
        }
      });
    },
    getList() {
      this.listLoading = true
      this.$axios({
        url: BASE_URL + 'groups/search',
        method: 'post',
        data: JSON.stringify(this.listQueryClass),
        //发送格式为json
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg
          this.total = res.data.total
          this.listLoading = false
        }
      })
    },
    onLibraryChange() {
      this.listQuery.Search.StrLibraryID = this.search.StrLibraryID;
      this.getBookList();
    },
    getSWList() {
      this.$axios({
        url: BASE_URL + "librarys",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.swList = res.data.msg;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    borrowBook() {
      if (this.strReaderCardNumber === '') {
        this.$message({
          message: '请输入读者卡号',
          type: "error",
        });
        return;
      } else if (this.chooseshowbook.length === 0) {
        this.$message({
          message: '请选择图书',
          type: "error",
        });
        return;
      } else if (this.BorrowTime === null || this.BorrowTime === undefined || this.BorrowTime === '') {
        console.log(this.BorrowTime);
        this.$message({
          message: '请选择借阅日期',
          type: "error",
        });
        return;
      }

      this.strBookBarcodes = '';
      for (let i in this.choose) {
        for (let j in this.choose[i].books) {
          this.strBookBarcodes += ',' + this.choose[i].books[j].code;
        }
      }
      this.strBookBarcodes = this.strBookBarcodes.slice(1);

      // 规范化日期（el-date-picker 的 value-format 在当前 Element Plus 版本下不可靠）
      // 选定借阅日期 + 当前时间（减一分钟），转 UTC 格式提交
      const now = new Date();
      now.setMinutes(now.getMinutes() - 1);
      const borrowDate = this.BorrowTime instanceof Date ? this.BorrowTime : new Date(this.BorrowTime);
      borrowDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

      this.book = {
        StrReaderCardNumber: this.strReaderCardNumber,
        StrBookBarcodes: this.strBookBarcodes,
        ReturnDays: this.returnday,
        StrLibraryID: this.search.StrLibraryID,
        BorrowTime: borrowDate.toISOString(),
      };
      this.$axios({
        url: BASE_URL + "books/quickBorrowReturn",
        method: "post",
        data: JSON.stringify(this.book),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.$message({
            message: '模拟借还成功',
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    clearchoosebook() {
      this.choose = [
        {
          page: this.listQuery.page,
          books: []
        }
      ];
      this.chooseshowbook = [];
      this.selectAll = false; // Reset "Select All" checkbox
      this.$refs.bookListTree.setCheckedKeys([], true);
    },
    handleSelectAll(checked) {
      if (checked) {
        // Select all nodes on the current page
        const allKeys = this.bookList.map(item => item.StrNodeId);
        this.$refs.bookListTree.setCheckedKeys(allKeys, true);
        // Update the choose array for the current page
        let chooseIndex = this.choose.findIndex(item => item.page === this.listQuery.page);
        if (chooseIndex === -1) {
          this.choose.push({ page: this.listQuery.page, books: [] });
          chooseIndex = this.choose.length - 1;
        }
        this.choose[chooseIndex].books = this.bookList.map(item => ({
          code: item.StrNodeId.split('|')[0],
          title: item.StrNodeId.split('|')[1]
        }));
      } else {
        // Deselect all nodes
        this.$refs.bookListTree.setCheckedKeys([], true);
        let chooseIndex = this.choose.findIndex(item => item.page === this.listQuery.page);
        if (chooseIndex !== -1) {
          this.choose[chooseIndex].books = [];
        }
      }
      // Update chooseshowbook
      this.chooseshowbook = [];
      for (let i in this.choose) {
        for (let j in this.choose[i].books) {
          this.chooseshowbook.push(this.choose[i].books[j]);
        }
      }
    },
    bookListNodeClick() {
      let chooseIndex = this.choose.findIndex(item => item.page === this.listQuery.page);
      if (chooseIndex === -1) {
        this.choose.push({ page: this.listQuery.page, books: [] });
        chooseIndex = this.choose.length - 1;
      }
      this.choose[chooseIndex].books = [];
      const checkedKeys = this.$refs.bookListTree.getCheckedKeys(true);
      checkedKeys.forEach(key => {
        const [code, title] = key.split('|');
        this.choose[chooseIndex].books.push({ code, title });
      });

      // Update chooseshowbook
      this.chooseshowbook = [];
      for (let i in this.choose) {
        for (let j in this.choose[i].books) {
          this.chooseshowbook.push(this.choose[i].books[j]);
        }
      }

      // Update selectAll state
      this.selectAll = checkedKeys.length === this.bookList.length && this.bookList.length > 0;
    },
    getBookList() {
      this.listLoading = true;
      this.$axios({
        url: BASE_URL + "books/search",
        method: "post",
        data: JSON.stringify(this.listQuery),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.total = res.data.total;
          this.bookList = res.data.msg.map(book => ({
            label: book.StrPositiveTitle,
            StrNodeId: `${book.StrBookBarcode}|${book.StrPositiveTitle}`
          }));

          // Restore checked state for the current page
          let chooseIndex = this.choose.findIndex(item => item.page === this.listQuery.page);
          if (chooseIndex !== -1) {
            const keys = this.choose[chooseIndex].books.map(book => `${book.code}|${book.title}`);
            this.$refs.bookListTree.setCheckedKeys(keys, true);
            // Update selectAll state
            this.selectAll = keys.length === this.bookList.length && this.bookList.length > 0;
          } else {
            this.selectAll = false;
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.listLoading = false;
      });
    },
    currPageChange(page) {
      this.listQuery.page = page;
      this.getBookList();
    },

    handleSizeChange(size) {
      this.listQuery.perPage = size;
      // this.listQuery.page = 1; // 切换条数时，重置为第一页
      this.getBookList();
    }
  }
}
</script>

<style scoped>
.box-card{
  width: 48%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}


</style>